import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export default makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'column nowrap',
      gap: theme.spacing(1.25),

      '& $row + $row': {
        marginTop: '12px',
      },

      '&$withInstructions': {
        background: COLORS.primary.silver,
        borderRadius: 6,
      },
    },
    withInstructionsRowWrapper: {
      margin: theme.spacing(1.25, 0),
    },

    row: {
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'flex-start',
      gap: theme.spacing(0.5),
    },
    title: {
      width: 64,
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(14),
      color: COLORS.gray.black,
      fontWeight: theme.typography.fontWeightSemiBold,
    },
    content: {
      flex: '1',
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
      color: COLORS.gray.gray40,
    },
    instructions: {
      flex: '1',
      marginLeft: 20,
      marginRight: 20,
      fontSize: 'inherit',
      lineHeight: 'inherit',
      marginTop: theme.spacing(1.25),
    },
    withInstructions: {},
  }),
  { name: 'ContentOutline' }
);
